import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, ZapIcon, InfinityIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="comprar" className="w-full py-16 md:py-24" style={{
    backgroundColor: '#FAFAF7'
  }} data-id="element-134">
      <div className="max-w-4xl mx-auto px-4" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-136">
          <div className="text-center mb-10" data-id="element-137">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6" style={{
            color: '#1A1A1A'
          }} data-id="element-138">
              Obtén acceso completo al Protocolo
            </h2>

            <p className="text-lg md:text-xl max-w-2xl mx-auto" style={{
            color: '#4A4A4A'
          }} data-id="element-139">
              Hoy puedes obtener el acceso completo al Protocolo Cero
              Inflamación en 72h por una fracción de lo que cuesta una consulta
              nutricional o una faja de alta calidad.
            </p>
          </div>

          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border-2 text-center" style={{
          borderColor: '#C9A96E'
        }} data-id="element-140">
            <div className="mb-8" data-id="element-141">
              <a href="https://pay.hotmart.com/M104747962U" target="_blank" rel="noopener noreferrer" data-id="element-142">
                <img src="https://cdn.magicpatterns.com/uploads/oGvffUNjs2TMMsCM4PyJLN/private_openrouter-generated-image-1772513941634.png" alt="Cero Inflamación en 72H" className="w-48 md:w-64 mx-auto mb-6 cursor-pointer" data-id="element-143" />
              </a>

              <p className="text-lg mb-2" style={{
              color: '#4A4A4A'
            }} data-id="element-144">
                Acceso inmediato por solo
              </p>

              <div className="flex items-center justify-center gap-3" data-id="element-145">
                <span className="text-5xl md:text-6xl font-bold" style={{
                color: '#C9A96E'
              }} data-id="element-146">
                  $15.000
                </span>
                <span className="text-2xl" style={{
                color: '#1A1A1A'
              }} data-id="element-147">
                  COP
                </span>
              </div>
            </div>

            <CTAButton text="¡SÍ, QUIERO DESINFLAMARME AHORA!" href="https://pay.hotmart.com/M104747962U" className="mb-6" data-id="element-148" />

            <div className="mb-8 text-center" data-id="element-149">
              <p className="text-sm font-medium mb-3" style={{
              color: '#4A4A4A'
            }} data-id="element-150">
                Métodos de pago
              </p>
              <img src="https://cdn.magicpatterns.com/uploads/3VmnjiHJjCpiRv8VG5oym4/image.png" alt="Métodos de pago: Débito/Crédito, Efecty, Nequi, PSE, Bancolombia, PayPal" className="w-full max-w-[280px] sm:max-w-xs md:max-w-sm lg:max-w-md mx-auto h-auto" data-id="element-151" />
            </div>

            <div className="flex flex-wrap items-center justify-center gap-6 text-sm" style={{
            color: '#4A4A4A'
          }} data-id="element-152">
              <div className="flex items-center gap-2" data-id="element-153">
                <ShieldCheckIcon className="w-5 h-5" style={{
                color: '#C9A96E'
              }} data-id="element-154" />
                <span data-id="element-155">Pago único</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-156">
                <InfinityIcon className="w-5 h-5" style={{
                color: '#C9A96E'
              }} data-id="element-157" />
                <span data-id="element-158">Acceso de por vida</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-159">
                <ZapIcon className="w-5 h-5" style={{
                color: '#C9A96E'
              }} data-id="element-160" />
                <span data-id="element-161">Descarga instantánea</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}